/**
 * @desc: - popup- 弹窗
 * @param  {[ARRAY]} ：list [banners list 数组 对象{path:"", href: ""}]
 * @param  {[FUNCTION]} ：onclose [上层改变DISPLAY为false]
 * @param  {[BLOON]} ：display [是否显示]
 * @param  {[number]} width [宽度]
 * @param  {[number]} height [高度]
 * @author: vico
 */
 import React from 'react';

 export default class Popup extends React.Component {

 	constructor(props){
 		super(props)
 	}
	
	 componentWillReceiveProps(nextProps) {
		
		 let isMaskDisplay = nextProps.display;
		 //初始化 this.oldDisplay 为false
		 if (this.oldDisplay == null || this.oldDisplay == undefined) {
			 this.oldDisplay = false
		 }
		 //监听 是否打开遮罩层，状态一致不再重复设置
		 if (isMaskDisplay !== this.oldDisplay) {
			 this.oldDisplay = isMaskDisplay;
			 if (isMaskDisplay) {
				 $.disableScroll();
			 } else {
				 $.enableScroll()
			 }
		 }
	 }

 	render(){
 		let {display, onclose, children, iclassName,width,height,className}  = this.props;
    className = className + " modal-popup-box" || "modal-popup-box"
    let _left = -(width/2);
    let _top = -(height/2)
    return (
      <div>
        <div className="modal-popup-mask" style={{display: display? 'block':'none'}}></div>
        <div className={className} style={{transform: display? 'scale(1,1)':'scale(0,0)',width:width,height:height,marginLeft:_left,marginTop:_top}}>
          <div className={iclassName}>
            {
              display ? React.Children.map(this.props.children, (item) => item) : null
            }
          </div>
					<div className="layer-close" onClick={onclose} />
        </div>
      </div>
    )
 	}

}